import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import _Object$entries from "@babel/runtime-corejs2/core-js/object/entries";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _Array$isArray from "@babel/runtime-corejs2/core-js/array/is-array";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types'; // @ts-ignore

import AsyncValidator from 'async-validator';
import debounce from 'lodash/debounce';
import isEqual from 'react-fast-compare';
import set from 'lodash/set';
import get from 'lodash/get';
import unset from 'lodash/unset';
import toPath from 'lodash/toPath';
import { clone as cloneDeep } from '@utiljs/clone';
import { isFunction } from '@utiljs/is';
import { FormProvider } from './connect';
import { isEmptyChildren, getValueFromTree, isValue, pruneEmpty, setRule } from './utils';

var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);

  var _super = _createSuper(Form);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _super.call(this, props);
    _this.fields = {};
    _this.initialValue = {}; // private cacheRule: any = {}

    _this.rules = {};

    _this.debounceValidate = function () {};

    _this.mountField = function (name, instance) {
      _this.fields[name] = true;

      if (instance.props.rule) {
        var insRule = instance.props.rule;
        var paths = toPath(name);
        var length = paths.length;
        var first = paths[0]; // 一级的情况下

        if (length === 1) {
          _this.rules[first] = insRule;
        } else if (length > 1) {
          _this.rules = setRule(name, _this.rules, insRule);
        }
      }
    };

    _this.unMountField = function (name) {
      _this.fields[name] = false; // this.removeRule(name);
    }; // rule => async-validator: 规则满足


    _this.formatName = function (name) {
      return toPath(name).join('.fields.');
    };

    _this.removeRule = function (name) {
      if (name) {
        unset(_this.rules, _this.formatName(name));
      }
    };
    /*
    * Form render props
     */


    _this.packChildProps = function () {
      var _this$props = _this.props,
          cols = _this$props.cols,
          disabled = _this$props.disabled;
      var _this$state = _this.state,
          values = _this$state.values,
          errors = _this$state.errors,
          touched = _this$state.touched,
          validating = _this$state.validating;
      return {
        values: values,
        rules: _this.rules,
        errors: errors,
        touchedFields: touched,
        validatingFields: validating,
        cols: cols,
        disabled: disabled,
        // handleReset: this.handleReset,
        // handleBlur: this.handleBlur,
        // handleChange: this.handleChange,
        // handleSubmit: this.handleSubmit,
        getFieldValue: _this.getFieldValue,
        setFieldValue: _this.setFieldValue,
        setFieldValues: _this.setFieldValues,
        getFiledError: _this.getFieldError,
        setFiledError: _this.setFieldError,
        setFiledTouched: _this.setFieldTouched,
        getFiledRule: _this.getFieldRule,
        validateField: _this.validateField,
        validateForm: _this.validateForm,
        resetForm: _this.handleReset,
        submitForm: _this.handleSubmit
      };
    };
    /**
     * Field consumer
     */


    _this.getContext = function () {
      var _this$props2 = _this.props,
          cols = _this$props2.cols,
          layout = _this$props2.layout,
          disabled = _this$props2.disabled;
      var _this$state2 = _this.state,
          values = _this$state2.values,
          errors = _this$state2.errors,
          touched = _this$state2.touched; // In order to update in the future, just expose special API

      return {
        values: values,
        rules: _this.rules,
        errors: errors,
        touched: touched,
        cols: cols,
        layout: layout,
        disabled: disabled,
        mountField: _this.mountField,
        unMountField: _this.unMountField,
        handleChange: _this.handleChange,
        handleBlur: _this.handleBlur
      };
    };
    /*
    * handle Field change
    * @curName Field bind name to handleChange
    * @eventOrKey ChangeEvent or string to current value
    */


    _this.handleChange = function (curName, eventOrKey, callback) {
      var fieldValue = '';
      var fieldName = curName; // @ts-ignore

      if (eventOrKey && eventOrKey.target) {
        // eventOrKey.persist();
        var _eventOrKey$target = eventOrKey.target,
            value = _eventOrKey$target.value,
            checked = _eventOrKey$target.checked,
            type = _eventOrKey$target.type,
            name = _eventOrKey$target.name;
        fieldValue = value;

        if (type === 'checkbox' || type === 'radio') {
          fieldValue = checked;
        } // INFO: if no name, use inner name


        fieldName = name || curName;
      } else {
        fieldName = curName; // @ts-ignore

        fieldValue = eventOrKey;
      }

      _this.setFieldValue(fieldName, fieldValue, false, function () {
        if (isFunction(callback)) {
          callback();
        }

        var trigger = _this.getFieldTrigger(fieldName);

        if (trigger.indexOf('onChange') > -1) {
          _this.debounceValidate(fieldName);
        }
      });
    };

    _this.handleBlur = function (name, event) {
      _this.setFieldTouched(name);

      if (event && event.target) {
        var _name = event.target.name;

        var trigger = _this.getFieldTrigger(_name);

        if (trigger.indexOf('onBlur') > -1) {
          _this.handleValidate(_name);
        }
      }
    };

    _this.handleFormPropsChange = function (name, value, values) {
      var onChange = _this.props.onChange;

      if (isFunction(onChange)) {
        onChange(name, value, values);
      }
    };
    /* eslint-disable @typescript-eslint/member-ordering */
    // debounceValidate = debounce((name: string) => {
    //     this.handleValidate(name);
    // }, this.props.validateDelay)

    /**
     * validator middleware. Maybe do something
     */


    _this.handleValidate = function (key) {
      _this.validateField(key);
    };

    _this.setFieldValues = function (values) {
      _this.setState({
        values: values
      }, function () {
        _this.handleFormPropsChange(null, null, values);
      });
    };
    /**
     * set Value
     * @description support nested object
     * @name field key
     * @value field value
     * @shouldValidate if validate after setting value
     */


    _this.setFieldValue = function (name, value, shouldValidate, callback) {
      var onChange = _this.props.onChange;

      _this.setState(function (state) {
        var temp = _Object$assign({}, state.values);

        set(temp, name, value);
        return _Object$assign(_Object$assign({}, state), {
          values: temp
        });
      }, function () {
        var values = _this.state.values;

        if (isFunction(onChange)) {
          onChange(name, value, values);
        }

        if (shouldValidate) {
          _this.validateField(name);
        }

        if (isFunction(callback)) {
          callback();
        }
      });
    };

    _this.setFieldError = function (name, message) {
      if (name) {
        _this.setState(function (state) {
          var temp = {};
          temp = _Object$assign({}, state.errors);
          set(temp, name, message);

          if (!isValue(message)) {
            temp = pruneEmpty(temp);
          }

          return {
            errors: temp
          };
        });
      }
    };
    /**
     * If a input has been visited/touched
     * INFO: label will trigger blur event
     * @name key
     */


    _this.setFieldTouched = function (name, value) {
      _this.setState(function (state) {
        var temp = _Object$assign({}, state.touched);

        set(temp, name, value !== undefined ? value : true);
        return {
          touched: temp
        };
      });
    };

    _this.setFieldValidating = function (name) {
      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      _this.setState(function (state) {
        var temp = _Object$assign({}, state.validating);

        set(temp, name, status);

        if (!status) {
          temp = pruneEmpty(temp, true);
        }

        return {
          validating: temp
        };
      });
    };

    _this.getFieldError = function (name) {
      var errors = _this.state.errors;
      return get(errors, name, undefined);
    };
    /**
     * Get special field value
     */


    _this.getFieldValue = function (name) {
      var values = _this.state.values;
      return get(values, name, undefined);
    };
    /**
     * Get special field rule
     */


    _this.getFieldRule = function (key) {
      // if cache, cant handle props updating
      // if (this.cacheRule[key]) {
      //     return this.cacheRule[key]
      // }
      // TODO: measure performance
      var temp = getValueFromTree(_this.rules, key); // this.cacheRule[key] = temp;

      return temp;
    };

    _this.getFieldTrigger = function (name) {
      var rule = _this.getFieldRule(name);

      if (rule) {
        var trigger = rule.trigger || _Array$isArray(rule) && rule[0].trigger;

        if (trigger && _Array$isArray(trigger)) {
          return trigger;
        } else if (typeof trigger === 'string') {
          return [trigger];
        }
      }

      return ['onChange'];
    };
    /**
     * Validate Field in real state
     */


    _this.validateField = function (name) {
      // Get nested rule
      var fieldRule = _this.getFieldRule(name);

      var validatorFieldRule = _defineProperty({}, name, fieldRule);

      if (fieldRule) {
        var validator = new AsyncValidator(validatorFieldRule);

        _this.setFieldValidating(name, true);

        validator.validate(_defineProperty({}, name, _this.getFieldValue(name)), function (errors, fields) {
          _this.setFieldValidating(name, false); // name 对应的 rule 是数组或者对象等，所以需要先行清空整个错误对象


          _this.setFieldError(name, null);

          if (errors) {
            errors.forEach(function (error) {
              _this.setFieldError(error.field, error.message);
            });
          }
        });
      }
    };
    /**
     * validate callback
     * @key
     * @value
     */
    // validateCallback = (key: string, message: any) => {
    //     if (key) {
    //         this.setState(state => ({
    //             errors: {
    //                 ...state.errors,
    //                 [key]: message
    //             }
    //         }))
    //     }
    // }

    /**
     * Validate form
     */


    _this.validateForm = function (callback) {
      var values = _this.state.values;
      var visibleRules = cloneDeep(_this.rules); // only validate visible component

      _Object$entries(_this.fields).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            value = _ref2[1];

        if (!value) {
          unset(visibleRules, _this.formatName(name));
        }
      });

      var validator = new AsyncValidator(visibleRules);
      validator.validate(values, {
        first: false
      }, function (errors, fields) {
        if (errors) {
          var tempError = {};
          errors.forEach(function (item) {
            set(tempError, item.field, item.message);
          });

          _this.setState({
            errors: tempError
          }, function () {
            if (isFunction(callback)) {
              callback(errors, fields);
            }
          });
        } else {
          _this.setState({
            errors: {}
          }, function () {
            if (isFunction(callback)) {
              callback(errors, fields);
            }
          });
        }
      });
    };

    _this.handleSubmit = function (eventOrCallback) {
      if (eventOrCallback && eventOrCallback.preventDefault) {
        eventOrCallback.preventDefault();
      }

      var onSubmit = _this.props.onSubmit;
      var values = _this.state.values;
      return new _Promise(function (resolve) {
        _this.validateForm(function (errors) {
          resolve(errors);
        });
      }).then(function (errors) {
        if (onSubmit) {
          return onSubmit(values, errors);
        }

        if (isFunction(eventOrCallback)) {
          eventOrCallback();
        }
      });
    };
    /**
     * Reset special Field
     */
    // resetField = (name: string) => {
    //     const {
    //         value
    //     } = this.props;
    //     this.setFieldValue(name, value[name] || '');
    // }

    /**
     * Reset all Fields
     */


    _this.handleReset = function (eventOrCallback) {
      if (eventOrCallback && eventOrCallback.preventDefault) {
        eventOrCallback.preventDefault();
      }

      _this.setState({
        values: cloneDeep(_this.initialValue),
        errors: {},
        touched: {}
      }, function () {
        var onReset = _this.props.onReset;

        if (onReset) {
          onReset();
        }

        if (isFunction(eventOrCallback)) {
          eventOrCallback();
        }
      });
    };

    _this.state = {
      isValid: false,
      initialValue: cloneDeep(props.value),
      values: cloneDeep(props.value),
      errors: {},
      touched: {},
      validating: {},
      alwaysUpdate: props.alwaysUpdate
    };
    _this.initialValue = cloneDeep(props.value);
    _this.fields = {};
    _this.rules = cloneDeep(props.rules); // this.cacheRule = {}; // 规则缓存
    // 放到这里是为了避免直接引用 lodash 的 types

    _this.debounceValidate = debounce(function (name) {
      _this.handleValidate(name);
    }, _this.props.validateDelay);
    return _this;
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var ctx = this.getContext();
      var props = this.packChildProps();
      return /*#__PURE__*/React.createElement(FormProvider, {
        value: ctx
      },
      /* eslint-disable */
      children ? isFunction(children) ? children(props) : !isEmptyChildren(children) // ? React.Children.only(children)
      ? children : null : null
      /* eslint-enable */
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if (!isEqual(nextProps.value, state.initialValue) && state.alwaysUpdate) {
        return _Object$assign(_Object$assign({}, state), {
          initialValue: nextProps.value,
          values: nextProps.value,
          errors: {},
          touched: {}
        });
      }

      return null;
    }
  }]);

  return Form;
}(React.Component);

Form.propTypes = {
  validateDelay: PropTypes.number,
  rules: PropTypes.object,
  cols: PropTypes.shape({
    field: PropTypes.object,
    label: PropTypes.object
  }),
  alwaysUpdate: PropTypes.bool,
  onChange: PropTypes.func,
  onReset: PropTypes.func,
  onSubmit: PropTypes.func,
  layout: PropTypes.string,
  disabled: PropTypes.bool
};
Form.defaultProps = {
  validateDelay: 300,
  rules: {},
  onChange: function onChange() {},
  onReset: function onReset() {},
  onSubmit: function onSubmit() {},
  cols: {
    field: {
      span: 4,
      offset: 0
    },
    label: {
      span: 2,
      offset: 0
    }
  },
  alwaysUpdate: true,
  layout: 'horizontal',
  disabled: false
};
export default Form;